import { DASHBOARD_TYPE } from 'shared/enum/enum';

import { IAnalyticsDashboard, IAnalyticsState } from './state';

export const analyticsReducers = {
	setDashboards: (state: IAnalyticsState, action: { payload: IAnalyticsDashboard[] }) => {
		state.dashboards.data = action.payload;
		const customerSpecificDashboard = action.payload.find(
			(dashboard) => dashboard.dashboardVertical === DASHBOARD_TYPE.CUSTOMER_SPECIFIC
		);
		state.customDashboardName = customerSpecificDashboard ? customerSpecificDashboard.dashboardName : '';
	},
	setDashboardsLoading: (state: IAnalyticsState, action: { payload: boolean }) => {
		state.dashboards.loading = action.payload;
	},
	setDashboardsError: (state: IAnalyticsState, action: { payload: boolean }) => {
		state.dashboards.error = action.payload;
	},
};
